export const keyCodes = {
  DOWN: 40,
  UP: 38,
  LEFT: 37,
  RIGHT: 39,
  ENTER: 13,
  BACK: 10009,
  SETTINGS: 10253,
  Play: 415,
  Pause: 19,
  Stop: 413,
  FastForward: 417,
  Rewind: 412,
  40: 'DOWN',
  38: 'UP',
  37: 'LEFT',
  39: 'RIGHT',
  13: 'ENTER',
  10009: 'BACK',
  10253: 'SETTINGS',
};
